import { render, staticRenderFns } from "./AuditsDetail.vue?vue&type=template&id=0d0602f8&scoped=true&"
import script from "./AuditsDetail.vue?vue&type=script&lang=ts&"
export * from "./AuditsDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0602f8",
  null
  
)

export default component.exports